/**
 * La zona roja de un courier (20261029010000): ahí entrega sólo coordinando, y el pedido queda en revisión hasta que el
 * courier lo confirme. La base la dice (`coordinar`, el nombre de su zona roja) en las opciones de envío, en Guías y al
 * registrar; la pantalla sólo la pinta con estas palabras, las mismas en todos lados.
 */

/** La marca corta, al lado de la tarifa: «zona roja: requiere coordinación». */
export const MARCA_DE_ZONA_ROJA = 'zona roja: requiere coordinación';

/**
 * Qué es una zona del mapa de un courier, en vez de su tarifa cuando no la tiene (Transporte → el courier → zonas): la
 * zona roja sin entrega, el contorno de su cobertura (dice hasta dónde llega; la tarifa sale del distrito) o la zona roja
 * que entrega coordinando.
 */
export function queDiceLaZona(z: { sin_entrega?: boolean; es_contorno?: boolean; requiere_coordinacion?: boolean }, tarifa: string): string {
  if (z.sin_entrega) return 'No se entrega';
  if (z.es_contorno) return 'Hasta dónde llega · la tarifa sale del distrito';
  if (z.requiere_coordinacion) return 'Zona roja · entrega coordinando';
  return tarifa;
}

/** Lo que pasa con el pedido, en una línea. */
export function queEsLaZonaRoja(courier: string): string {
  return `Requiere coordinación con ${courier}: el pedido queda en revisión hasta que ${courier} lo confirme.`;
}
